import React, {Component} from 'react';
import {func, string} from 'prop-types';
import moment from 'moment';

import DatePickerInput from '../../../DatePickerInput/DatePickerInput';
import Checkbox from '../../../Checkbox/Checkbox';

import cx from 'classnames';
import s from './CreateNewUser.css';
import {
  getEHNACPasswordRequirements,
  validateEHNACPassword
} from "../../../../lib/PasswordUtils";


export default class CreateNewUser extends Component {
  static propTypes = {
    createUser: func,
    dateFormat: string,
  };

  static defaultProps = {
    dateFormat: 'YYYY-MM-DD',
  };

  constructor(props) {
    super(props);

    this.maxReasonLength = 256;

    this.state = {
      misMatchError: false,
      validPasswordError: false,

      firstName: '',
      lastName: '',
      username: '',
      password: '',
      confirmPassword: '',
      expiration: null,
      reason: '',
      authNewUser: false,

      minDate: moment().add(1, 'days').format(props.dateFormat),
    };
  }

  validatePassword = () => {
    if (this.state.password !== this.state.confirmPassword) {
      this.setState({
        misMatchError: true,
      });
    } else if (!validateEHNACPassword(this.state.password)){
      this.setState({
        misMatchError: false,
        validPasswordError: true,
      });
    } else {

      this.setState({
        misMatchError: false,
        validPasswordError: false,
      });
      return true;
    }
  };

  handleSubmit = (e) => {
    e.preventDefault();

    const formValues = {
      firstName: this.state.firstName,
      lastName: this.state.lastName,
      username: this.state.username,
      password: this.state.password,
      confirmPassword: this.state.confirmPassword,
      expiration: this.state.expiration,
      reason: this.state.reason,
      isauthnewuser: this.state.authNewUser,
    };

    if (this.validatePassword()) {

      this.props.createUser(formValues);

    }
  }

  handleExpirationChange = expiration => this.setState({ expiration });

  render = () => {
    return (
      <section className={s.component}>
        <h3 className={s.header}>
          Create a New User
        </h3>
        <form
          id="newUser"
          className={s.form}
          onSubmit={this.handleSubmit}
        >
          <p>
            All fields, unless otherwise noted, are required.
          </p>
          <div className={s.groupStacked}>
            <p className={s.helpText}>
              First and last names can only contain letters and spaces.
            </p>
            <p className={s.helpText}>
              Username may only use letters, numbers, dashes (-), underscores (_),
               periods (.), at signs (@), or plus signs (+).
            </p>
            <p className={s.helpText}>
              Passwords must contain:<br />
              - 1 or more uppercase letters<br />
              - 1 or more lowercase letters<br />
              - 1 or more numbers OR special characters<br />
              - Between 10 and 30 valid characters
            </p>
          </div>

          <div className={s.group}>
            <label className={s.label} htmlFor="newUserFirstName">
              First Name
            </label>
            <div className={s.controlContainer}>
              <input
                id="newUserFirstName"
                name="newUserFirstName"
                required
                className={s.control}
                type="text"
                placeholder="Type First Name..."
                value={this.state.firstName}
                onChange={(event) => this.setState({ firstName: event.target.value })}
              />
            </div>
          </div>

          <div className={s.group}>
            <label className={s.label} htmlFor="newUserLastName">
              Last Name
            </label>
            <div className={s.controlContainer}>
              <input
                id="newUserLastName"
                name="newUserLastName"
                required
                className={s.control}
                type="text"
                placeholder="Type Last Name..."
                value={this.state.lastName}
                onChange={(event) => this.setState({ lastName: event.target.value })}
              />
            </div>
          </div>

          <div className={s.group}>
            <label className={s.label} htmlFor="newUserUsername">
              Username
            </label>
            <div className={s.controlContainer}>
              <input
                id="newUserUsername"
                name="newUserUsername"
                className={s.control}
                type="text"
                pattern={"^[A-Za-z0-9-.@+_]+$"}
                placeholder="Type Username..."
                maxLength={100}
                value={this.state.username}
                onChange={(event) => this.setState({ username: event.target.value })}
              />
            </div>
          </div>

          <div className={s.group}>
            <label className={s.label} htmlFor="newUserPassword">
              Password
            </label>
            <div className={s.controlContainer}>
              <input
                id="newUserPassword"
                name="newUserPassword"
                className={s.control}
                type="password"
                placeholder="Type Password..."
                required
                value={this.state.password}
                onChange={(event) => this.setState({ password: event.target.value })}
              />
            </div>
          </div>

          <div className={s.group}>
            <label className={s.label} htmlFor="newUserConfirmPassword">
              Confirm Password
            </label>
            <div className={s.controlContainer}>
              <input
                id="newUserConfirmPassword"
                name="newUserConfirmPassword"
                className={s.control}
                type="password"
                placeholder="Confirm Password..."
                required
                value={this.state.confirmPassword}
                onChange={(event) => this.setState({ confirmPassword: event.target.value })}
              />
            </div>
          </div>

          <div className={s.group}>
            <label className={s.label} htmlFor="newUserExpiration">
              Expiration Date (optional)
            </label>
            <div className={s.controlContainer}>
              <DatePickerInput
                className={s.dateFilter}
                dateFormat={this.props.dateFormat}
                id="newUserExpiration"
                hasInputBorder
                minDate={this.state.minDate}
                onChange={this.handleExpirationChange}
                value={this.state.expiration}
              />
            </div>
          </div>

          <div className={s.group}>
            <label className={s.label} htmlFor="newUserReason">
              Reason (optional)
            </label>
            <div className={cx(s.controlContainer, s.textAreaContainer)}>
              <textarea
                className={cx(s.control, s.textarea)}
                rows="5"
                name="newUserReason"
                id="newUserReason"
                placeholder="Type Reason (optional)..."
                value={this.state.reason}
                maxLength={this.maxReasonLength}
                onChange={(event) => this.setState({ reason: event.target.value })}
              />
              <span>
                {this.maxReasonLength - this.state.reason.length} characters remaining.
              </span>
            </div>
          </div>

          <div className={s.group}>
            <div className={s.controlContainer}>
              <Checkbox
                  id="authNewUser"
                  required
                  checked={this.state.authNewUser}
                  onChange={()=> this.setState({authNewUser: !this.state.authNewUser})}
              />
              <label className={s.checkboxLabel} htmlFor="authNewUser">
                By creating this designated user, I authorize them to access my health information. I understand that I am granting the designated user access to past, current, and future health information, which may include sensitive information. I acknowledge that I have the ability to disable access at any time.
              </label>
            </div>
          </div>

          <div className={s.group}>
            <button
              type="submit"
              id="newUserSubmit"
              className={s.btn}
            >
              Create User
            </button>
          </div>

          {this.state.misMatchError &&
            <p className={s.helpText}>
              New and Confirm Password fields do not match. Please try again.
            </p>
          }
          {this.state.validPasswordError &&
            <p className={s.helpText}>
              Your password isn&rsquo;t strong enough. Please review the password requirements and try again.
              {getEHNACPasswordRequirements()}
            </p>
          }
        </form>
      </section>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Pages/Account/CreateNewUser/CreateNewUser.js